export var cibPinboard = ["32 32", "<path d='M17.802 19.448l-6.010 6.151 0.958-5.417-8.177-10.089-4.573 0.245 10.104-10.339v3.938l9.62 8.859 6.021-1.474-6.255 6.646 12.51 14.031z'/>"];
